function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function subscribePush(api) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Este navegador no soporta avisos push.");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Necesitamos tu permiso para activar los avisos.");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/notificaciones/vapid-public-key");
  if (!data.key) throw new Error("Los avisos al celular todavía no están configurados.");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.key) });
  }
  await api.post("/notificaciones/suscribir", { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribePush(api) {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.delete("/notificaciones/suscribir", { params: { endpoint: sub.endpoint } });
    await sub.unsubscribe();
  }
}
